import Vue from 'vue'
import Keyboard from './keyboard'
import Global from './global'
import Directives from '@/directives'
Vue.use(Global)
Vue.use(Directives)
Vue.use(Keyboard)
